import { useQuery } from "@tanstack/react-query";
import { apiJson } from "./queryClient";
import type { GermanEnergyInfrastructureResponse } from "@shared/germanEnergyInfrastructure";

export function useGermanEnergyInfrastructure(
  latitude: number,
  longitude: number,
  radiusKm = 5,
  countryIso = "DE",
  enabled = true,
) {
  const searchRadiusKm = Math.min(5, Math.max(0.5, radiusKm));
  const params = new URLSearchParams({
    lat: String(latitude),
    lon: String(longitude),
    radiusKm: String(searchRadiusKm),
    countryIso,
  });
  const route = `/api/proxy/german-energy-infrastructure?${params.toString()}`;
  return useQuery<GermanEnergyInfrastructureResponse>({
    queryKey: ["energy-infrastructure", countryIso, latitude, longitude, searchRadiusKm],
    queryFn: () => apiJson<GermanEnergyInfrastructureResponse>("GET", route),
    enabled: enabled && Number.isFinite(latitude) && Number.isFinite(longitude),
    staleTime: 15 * 60 * 1000,
    retry: 0,
  });
}
